export const getProductImageSrc = (image) => {
  if (!image) {
    return "";
  }
  if (typeof image === "string") {
    return image;
  }
  return image.cdn_link || image.url || "";
};

const glbPath = (src) => {
  const value = (src || "").split("?")[0].split("#")[0].toLowerCase();
  const encodedQuery = value.indexOf("%3f");
  return encodedQuery === -1 ? value : value.slice(0, encodedQuery);
};

export const isGlbProductImage = (image) => {
  if (!image) {
    return false;
  }
  if (
    typeof image === "object" &&
    (image.type === "glb" || image.media_type === "glb")
  ) {
    return true;
  }
  return glbPath(getProductImageSrc(image)).includes(".glb");
};

export const normalizeGlbUrl = (url) => {
  if (!url) {
    return "";
  }
  const marker = url.toLowerCase().indexOf(".glb");
  if (marker === -1) {
    return url;
  }
  return url.slice(0, marker + 4);
};

export const toGlbProxyUrl = (url) => {
  const normalized = normalizeGlbUrl(url);
  if (!normalized) {
    return "";
  }
  if (
    normalized.startsWith("/api/glb") ||
    normalized.startsWith("/") ||
    normalized.startsWith("blob:") ||
    normalized.startsWith("data:")
  ) {
    return normalized;
  }
  return `/api/glb?src=${encodeURIComponent(normalized)}`;
};

export const getRasterProductImages = (images) =>
  (images || []).filter((img) => !isGlbProductImage(img));
